/**
 * Main.js
 *
 * @since 1.0.0
 */

// import 'smoothscroll'
import 'objectFitPolyfill'
import objectFitImages from 'object-fit-images'
import Raven from 'raven-js'
import FontFaceObserver from 'fontfaceobserver'
import FormValidation from './modules/FormValidation'
import YoutubeVideos from './modules/YoutubeVideos'
import LazyLoadBackground from './modules/LazyLoadBackground'
import MobileNav from './modules/MobileNav'
import NavDropdown from './modules/NavDropdown'
import ScrollDown from './modules/ScrollDown'
import Slider from './modules/Slider'
import StickyCTA from './modules/StickyCTA'
import SendForm from './modules/SendForm'
import Maps from './modules/Map'
import TrackUtmVars from './modules/TrackUtmVars'
import VideoHero from './modules/VideoHero'
import UploadButton from './modules/UploadButton'
import PolyFill from './modules/PolyFill'
import ProductDetail from './modules/ProductDetail'
import HeroSlider from './modules/HeroSlider'
import StepsForm from './modules/StepsForm'
import Popup from './modules/Popup'
import Referral from './modules/Referral'
import ZipcodeAPI from './modules/ZipcodeAPI'
import DatePicker from './modules/DatePicker'
import DependsOn from './modules/DependsOn'
import Lightbox from './modules/Lightbox'
import StickyShare from './modules/StickyShare'
import SharePopup from './modules/SharePopup'
import BlogTermsSelect from './modules/BlogTermsSelect'
import LazyLoadImage from './modules/LazyLoadImage'
import LazyLoadPicture from './modules/LazyLoadPicture'
import Tabs from './modules/Tabs'
import Toggle from './modules/Toggle'
import FullscreenPopup from './modules/FullscreenPopup'
// import LazyLoadVideo from './modules/LazyLoadVideo'
import 'whatwg-fetch'
;(function IIFE() {
  if (process.env.NODE_ENV === 'production') {
    Raven.config('https://3b8864135a2841cbbf766ec2669301cb@sentry.io/159176').install()
  }
  objectFitImages()
  FormValidation()
  LazyLoadBackground()
  MobileNav()
  NavDropdown()
  ScrollDown()
  YoutubeVideos()
  SendForm()
  Maps()
  TrackUtmVars()
  VideoHero()
  UploadButton()
  PolyFill()
  StickyCTA()
  ProductDetail()
  HeroSlider()
  StepsForm()
  Popup()
  Referral()
  ZipcodeAPI()
  DatePicker()
  DependsOn()
  Lightbox()
  StickyShare()
  Slider()
  SharePopup()
  BlogTermsSelect()
  LazyLoadImage()
  LazyLoadPicture()
  Tabs()
  Toggle()
  FullscreenPopup()
  // LazyLoadVideo()

  const font = new FontFaceObserver('Campton')
  font.load().then(() => {
    if (!document.documentElement.classList.contains('fonts-loaded')) {
      document.documentElement.classList.add('fonts-loaded')
    }
  })
})()



// WEBPACK FOOTER //
// ./src/js/main.js